export default function app(state = {}, action) {
    switch (action.type) {
    case 'CHANGE_MODE':
        return { ...state, mode: action.mode };
    case 'SET_APP_ID':
        return { ...state, id: action.id };
    case 'SET_TEMPLATE_ID':
        return { ...state, template: action.id };
    case 'SET_APP_NAME':
        return { ...state, name: action.name };
    case 'SET_PRIMARY_COLOR':
        return { ...state, primaryColor: action.color };
    case 'SET_SECONDARY_COLOR':
        return { ...state, secondaryColor: action.color };
    case 'SET_APP_SHARE_URL':
        return { ...state, shareUrl: action.url };
    case 'SET_APP_EMAIL':
        return { ...state, email: action.email };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/_app/quick_response/reducers/app_reducers.js